<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        style="fill: currentColor"
    >
        <path
            d="M486.03-285Q502-285 513-296.03q11-11.03 11-27T512.97-350q-11.03-11-27-11T459-349.97q-11 11.03-11 27T459.03-296q11.03 11 27 11ZM453-433h57q0-15 2-26.5t7-22.5q5-11 14-22t22.14-24.14Q588-561 601-586.5t13-53.5q0-53-34-84t-91.52-31q-51.87 0-88.17 24.5Q364-706 347-663l53 22q14-28 36.2-42.5Q458.4-698 488-698q32 0 50.5 16t18.5 44.1q0 19.9-11 38.4t-37 43.99q-17 15.51-27.5 28.37Q471-514.29 464-500q-5.92 14.37-8.46 30.19Q453-454 453-433Zm27 393L360-160H180q-24 0-42-18.5T120-220v-600q0-24 18-42t42-18h600q23 0 41.5 18t18.5 42v600q0 23-18.5 41.5T780-160H600L480-40ZM180-220h204l96 96 96-96h204v-600H180v600Zm300-297Z"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "live_help",
});
</script>
